import { useState } from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAddOutlined";
import { useSelector } from "react-redux";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import { success } from "../../util/ToastUtil";
import { addList } from "./api-aluno-turma";

// Aceita códigos separados por vírgula, ponto e vírgula, espaço ou quebra de linha.
const parseCodigos = (texto) => [...new Set(texto.split(/[\s,;]+/).map((c) => c.trim()).filter(Boolean))];

const AlunoTurmaFormList = ({ onAdded }) => {
  const turma = useSelector((state) => state.turma);
  const [texto, setTexto] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const codigos = parseCodigos(texto);

  const clickSubmit = (event) => {
    event.preventDefault();
    if (codigos.length === 0) return;
    setIsSaving(true);
    addList(codigos, turma.codigo)
      .then((data) => {
        if (!data) return;
        if (data.error) {
          errorMessage(data.message);
          return;
        }
        success(`${codigos.length} aluno(s) adicionado(s) à turma.`);
        setTexto("");
        onAdded?.();
      })
      .finally(() => setIsSaving(false));
  };

  return (
    <Stack component="form" onSubmit={clickSubmit} spacing={2}>
      <Alert severity="info">
        Informe os códigos dos alunos separados por vírgula ou um por linha (ex.: 458, 459, 460). Todos serão
        adicionados de uma vez, com a data de entrada de hoje.
      </Alert>
      <TextField
        multiline
        minRows={3}
        fullWidth
        label="Códigos dos alunos"
        value={texto}
        onChange={(event) => setTexto(event.target.value)}
        helperText={codigos.length > 0 ? `${codigos.length} código(s) identificado(s)` : " "}
      />
      <Box>
        <Button
          type="submit"
          variant="contained"
          startIcon={isSaving ? <CircularProgress size={18} color="inherit" /> : <PlaylistAddIcon />}
          disabled={isSaving || codigos.length === 0}
        >
          Adicionar {codigos.length > 0 ? codigos.length : ""} aluno(s)
        </Button>
      </Box>
    </Stack>
  );
};

export default AlunoTurmaFormList;
